var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.33301C16.5 14.1663 9 19.1663 9 19.1663C9 19.1663 1.5 14.1663 1.5 8.33301C1.5 6.34388 2.29018 4.43623 3.6967 3.02971C5.10322 1.62318 7.01088 0.833008 9 0.833008C10.9891 0.833008 12.8968 1.62318 14.3033 3.02971C15.7098 4.43623 16.5 6.34388 16.5 8.33301Z",
    stroke: "#92D050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.833C10.3807 10.833 11.5 9.71372 11.5 8.33301C11.5 6.9523 10.3807 5.83301 9 5.83301C7.61929 5.83301 6.5 6.9523 6.5 8.33301C6.5 9.71372 7.61929 10.833 9 10.833Z",
    stroke: "#92D050",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacemark);
export default __webpack_public_path__ + "static/media/placemark.4608094255eea9cd6fa3cd15b72667c6.svg";
export { ForwardRef as ReactComponent };